import { api } from "../api";

// ============================================================
// Смена email — 2 шага
// ============================================================

export interface RequestEmailChangeResponse {
  masked_email: string;
  expires_in_sec: number;
}

export async function requestEmailChange(
  newEmail: string,
): Promise<RequestEmailChangeResponse> {
  const res = await api.post<RequestEmailChangeResponse>(
    "/me/email/request-change",
    { newEmail },
  );
  return res.data;
}

export async function confirmEmailChange(
  newEmail: string,
  code: string,
): Promise<{ email: string }> {
  const res = await api.post<{ email: string }>("/me/email/confirm-change", {
    newEmail,
    code,
  });
  return res.data;
}

// ============================================================
// Смена телефона — 1 шаг + PIN
// ============================================================

export async function changePhone(
  newPhone: string,
  pin: string,
): Promise<{ phone_number: string }> {
  const res = await api.post<{ phone_number: string }>("/me/phone/change", {
    newPhone,
    pin,
  });
  return res.data;
}

// ============================================================
// P2P settings
// ============================================================

export async function updateP2pSettings(
  allowTransfers: boolean,
): Promise<{ allow_p2p_transfers: boolean }> {
  const res = await api.patch<{ allow_p2p_transfers: boolean }>(
    "/me/p2p-settings",
    { allowTransfers },
  );
  return res.data;
}

// ============================================================
// P2P — поиск, перевод, история
// ============================================================

export interface P2pRecipient {
  id: string;
  display_name: string;
  avatar_url: string | null;
  masked_contact: string;
}

export async function findP2pRecipient(
  query: string,
): Promise<P2pRecipient | null> {
  const res = await api.post<P2pRecipient | null>("/me/p2p/find-recipient", {
    query,
  });
  return res.data;
}

export interface P2pTransferResult {
  id: string;
  currency: string;
  amount: string;
  recipient: { id: string; display_name: string };
  created_at: string;
}

export async function makeP2pTransfer(payload: {
  recipientId: string;
  currency: string;
  amount: string;
  comment?: string;
  pin: string;
}): Promise<P2pTransferResult> {
  const res = await api.post<P2pTransferResult>("/me/p2p/transfer", payload);
  return res.data;
}

export interface P2pHistoryItem {
  id: string;
  direction: "in" | "out";
  currency: string;
  amount: string;
  comment: string | null;
  counterparty: {
    id: string;
    display_name: string;
    avatar_url: string | null;
  };
  created_at: string;
}

export async function getP2pHistory(limit = 30): Promise<P2pHistoryItem[]> {
  const res = await api.get<P2pHistoryItem[]>(`/me/p2p/history?limit=${limit}`);
  return res.data;
}
